import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider as StoreProvider } from 'mobx-react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { WatcherrError, WatcherrNetworkError } from '@watcherr/resources';
import * as Sentry from '@sentry/react';
import { initializeStore } from '~/store';
import { setResources } from './services/resources';
import App from './App';
import './styles/main.css';
import 'react-day-picker/dist/style.css';

// Initialize Sentry
if (import.meta.env.VITE_DISABLE_SENTRY !== 'true') {
  Sentry.init({
    dsn:
      import.meta.env.VITE_SENTRY_DSN ||
      'https://44b1aeada0614e0da82dc86c241c7f5e@o4509474952511568.ingest.de.sentry.io/4509474952904791',
    environment: import.meta.env.VITE_APP_ENV || 'production',
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.01,
    replaysOnErrorSampleRate: 0.1,
  });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: (failureCount: number, error: WatcherrError) => {
        if (failureCount < 3 && error instanceof WatcherrNetworkError) {
          return true;
        }
        return false;
      },
    },
  },
});

const mobxStore = initializeStore();

// Initialize resources
setResources();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <StoreProvider {...mobxStore}>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StoreProvider>
);
